import { ObjectWithAnyValues } from "utils/types";
import { BaseModel } from "../BaseModel";
import { TermType } from "./TermType";
import { TermFields, TermProps, TermTypeProps } from "./types";

export class Term extends BaseModel {
	[TermFields.ID]: string;
	[TermFields.TENANT_ID]: string;
	[TermFields.PDF_URL]: string;
	[TermFields.START_DATE]?: string;
	[TermFields.CANCELED]: string;
	[TermFields.TYPE]: TermTypeProps;
	[TermFields.STATUS]?: string;
	[TermFields.FILE_NAME]?: string;

	constructor(data: TermProps) {
		super(data);

		this[TermFields.ID] = data[TermFields.ID];
		this[TermFields.TENANT_ID] = data[TermFields.TENANT_ID];
		this[TermFields.PDF_URL] = data[TermFields.PDF_URL];
		this[TermFields.START_DATE] = data[TermFields.START_DATE];
		this[TermFields.CANCELED] = data[TermFields.CANCELED];
		this[TermFields.TYPE] = data.type && new TermType(data.type);
		this[TermFields.STATUS] = data[TermFields.STATUS];
	}

	static override createFromResponse(response: ObjectWithAnyValues) {
		if (!response) {
			return response;
		}

		const term = new Term({
			[TermFields.ID]: response.id,
			[TermFields.TENANT_ID]: response.tenantId,
			[TermFields.PDF_URL]: response.pdfUrl,
			[TermFields.START_DATE]: response.startDate,
			[TermFields.CANCELED]: response.canceled,
			[TermFields.TYPE]: response.type,
			[TermFields.STATUS]: response.status
		});
		return term;
	}
}
